import { FlexBox, Text } from '@helloself/hello-self-ui';
import React from 'react';

export function SubmitSuccess() {
    return (
        <FlexBox alignSelf="stretch">
            <Text textColor="green" fontWeight="600" textSize="small">
                Successfully updated
            </Text>
        </FlexBox>
    );
}
